import { ALT_METHODS, SELECTED_METHOD_ID } from 'store/constants';
import type { UIPaymentGroups } from 'store/formatters';
import { sortByArrangement } from 'store/formatters';

import { filterMethodsByPayType } from './common';
import { stringToInt } from './dataTransform';
import { isMethodAvailable } from './getIsMethodActive';
import { softLocalStorageGet } from './storage';

export const getMethodsToShow = (
  methodsToFilter: UIPaymentGroups[],
  userAgent?: string,
  appChannel?: string,
): UIPaymentGroups[] => {
  const methods = methodsToFilter || softLocalStorageGet(ALT_METHODS);

  if (!methods?.length) {
    return [];
  }

  const selectedBeforeMethodId = stringToInt(softLocalStorageGet(SELECTED_METHOD_ID) || '') ?? undefined;
  let sorted: UIPaymentGroups[];

  try {
    const filteredMethodsByRestrictions = (
      typeof methods === 'string' ? (JSON.parse(methods) as UIPaymentGroups[]) : methods
    ).filter((method) => isMethodAvailable(method));

    const methodsByPayType = filterMethodsByPayType(filteredMethodsByRestrictions, userAgent, appChannel);

    sorted = methodsByPayType.sort(sortByArrangement);
  } catch (e) {
    return [];
  }

  const inSorted =
    selectedBeforeMethodId !== undefined ? sorted.findIndex(({ id }) => id === selectedBeforeMethodId) : -1;

  if (inSorted !== -1) {
    sorted.splice(inSorted, 1);
  }

  return sorted.splice(0, 2);
};
